import styled, { css } from 'styled-components';
import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';
import { CarouselStyles } from './Carousel.style';

type ContainerProps = {
  isNew?: boolean;
  isTier3?: boolean;
  hasDealerImages?: boolean;
};

type ImageProps = {
  isNewVehicle: boolean;
  isReservedVehicle?: boolean;
  isTier3?: boolean;
  imageType?: string;
  bodyType?: string | null;
  hasDealerImages?: boolean;
};

export const CarouselContainer = styled(CarouselStyles)<ContainerProps>`
  position: relative;
  ${({ isTier3, isNew }) => {
    if (isNew) return css``;
    if (!isNew && !isTier3)
      return css`
        max-height: 195px;
      `;
    if (!isNew && isTier3)
      return css`
        max-height: 254px;
        @media ${device.tablet} {
          max-height: 318px;
        }
      `;
    return '';
  }}
  ${({ isTier3 }) => {
    if (isTier3)
      return css`
        .slick-prev {
          left: 4px;
        }
        .slick-next {
          right: 4px;
        }
      `;
    return '';
  }}
  background-color: ${({ isNew, isTier3 }) => ((isTier3 && isNew) || isNew ? COLORS.grey5 : '')};

  ${({ isNew, isTier3, hasDealerImages }) => {
    if (isTier3 && isNew && hasDealerImages)
      return css`
        background-color: ${COLORS.white};
      `;
    if (isNew)
      return css`
        background-color: ${COLORS.grey5};
      `;
    return '';
  }}
  .slick-prev:before,
  .slick-next:before {
    // remove the default arrow button of carousel library
    content: none;
  }
`;

export const ArrowContainer = styled.button`
  border: none;
  width: 48px;
  height: 48px;
  svg {
    background-color: ${COLORS.grey5};
  }
`;

export const PaginationCounter = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: ${COLORS.grey5};
  width: 51px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${COLORS.grey60};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
  span {
    color: black;
  }
`;

export const VehicleImage = styled.img<ImageProps>`
  object-fit: contain;
  height: ${({ isTier3 }) => (isTier3 ? '254px' : '195px')};
  @media ${device.tablet} {
    height: ${({ isTier3 }) => (isTier3 ? '318px' : '100%')};
  }
  scale: ${({ isNewVehicle }) => isNewVehicle && '1.12'};
  opacity: ${({ isReservedVehicle }) => isReservedVehicle && '0.5'};
  max-height: ${({ isTier3 }) => (isTier3 ? '318px' : '195px')};
  ${({ imageType, bodyType, isNewVehicle }) => {
    if (imageType === 'dashboard_interior')
      return css`
        object-fit: cover;
        scale: 1.0003;
        // max-width: 308px;
        @media ${device.tablet} {
          // max-width: 373px;
        }
      `;
    if (imageType === 'front_facing' && (bodyType === 'SUV' || bodyType === 'allroad quattro'))
      return css`
        scale: ${isNewVehicle && '0.9'};
      `;
    if (imageType === 'back_facing' && (bodyType === 'SUV' || bodyType === 'allroad quattro'))
      return css`
        scale: ${isNewVehicle && '0.9'};
      `;
    return '';
  }}
  // only for Tier 3
  scale: ${({ isTier3, isNewVehicle, imageType }) =>
    isTier3 && isNewVehicle && imageType !== 'dashboard_interior' && '1'};
`;
